import PromptInput from "common/widgets/PromptList/PromptInput";
import DFSwitch from "common/widgets/DFSwitch/DFSwitch";

const SwitchPromptInput = PromptInput.extend({
    options: {
        name: "SwitchPromptInput"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        this.widget = new DFSwitch(this.input, {
            onLabel: this.options.model.get("labelTrue"),
            offLabel: this.options.model.get("labelFalse")
        });
        this.input.removeAttr("required");
        this.widget.bind("change", this.handleChange);
        // set class needed for applying styles to set width / height / labelPosition correctly,
        // based on control type
        if(this.options.model.width && this.options.model.height) {
            this.element.parent()
                .addClass("flexLayout")
                .addClass("checkboxControl");
        }

        var fullId = this.options.parentId + "_" + this.options.id;
        this.element.parent().find("label[for='" + fullId + "']").attr("for", fullId + "_check");

        this.refresh();
    },

    destroy: function() {
        if(this.widget) {
            this.widget.unbind("change", this.handleChange);
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    // Only call readOnly when not absolutely positioned. Otherwise, enabled handling displays the readonly (disabled)
    // mode of the control. When absolutely positioned, we want to display a disabled checkbox instead of our special readonly mode.
    readonly: function(val) {
        if(!this.options.disabledWhenReadonly) {
            PromptInput.fn.readonly.call(this, val);
        } else {
            this._readonlyEnable(val);
        }
    },

    /**
     * Override to prevent tabindex set on input since dfswitch has an atypical tabindex handler
     * @private
     */
    disableTabbable: function() {
        var widget = this.widget;
        if(widget && widget.model) {
            widget.model.set("tab", "-1");
        }
    },

    /**
     * Override
     */
    setCorrectedSize: function() {
        PromptInput.fn.setCorrectedSize.apply(this, arguments);
        // always set width since this control no longer accepts variable width via user resize
        var labelWidth = this.label.outerWidth();
        var inputWidth = this.widget.widget.outerWidth();
        var width = labelWidth + inputWidth;
        if(this.options.model.labelPosition === "TOP" || this.options.model.labelPosition === "BOTTOM") {
            width = Math.max(labelWidth, inputWidth);
        }
        this.options.width = width;
    },

    /**
     * Override
     */
    getInputWidth: function() {
        return this.widget.getARIAElements().outerWidth(true);
    },

    _blurrable: function(){
        return this.element.find(".checkSwitch>input");
    }

});
kendo.ui.plugin(SwitchPromptInput);
export default SwitchPromptInput;
